<div id="floatingNotifications" *ngIf="numberOfNotifications > 0">

    <button mat-fab [ngClass]="{'md-fab-bottom-right': fixedToBottomRight}" color="warn"
        matBadge="{{numberOfNotifications}}" aria-label="" (click)="showNotifications()">
        <mat-icon>warning</mat-icon>
    </button>

</div>